console.log(new Date().getTime(),'初始化main.js');
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "amfe-flexible/index.js";
import store from "./store";
import {getModules} from "./api/getModules";
import api from "./api/api";
Vue.prototype.$getModules = getModules;
Vue.config.productionTip = false;
Vue.prototype.$api = api;
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'gH7hIADk7WjYpTlHB398HiYlFN9l4ds5'
})
import Vant from 'vant';
import 'vant/lib/index.css';
import './assets/font/iconfont/iconfont.css'

import elementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import wsConnection from './utils/socket'
Vue.prototype.$setWs = wsConnection;

Vue.use(elementUI)

Vue.use(Vant);

// // 使用 vue-meta
// import Meta from "vue-meta";
// Vue.use(Meta);
import "vant/lib/index.css";
// import Vconsole from "vconsole";
// //开发环境使用，生产环境自动取消
// if (process.env.NODE_ENV == "development") {
//     new Vconsole();
// }
new Vue({
    router,store,
    render: (h) => h(App),
}).$mount("#app");
